<div class="relative-div">
    @if (loading()) {
    <div class="spinner-overlay">
        <mat-spinner></mat-spinner>
    </div>
    }

    <mat-stepper #stepper linear>
        <mat-step [stepControl]="registrationFormGroup" label="Registration data">
            <form [formGroup]="registrationFormGroup">
                <!-- honeypot: hidden from humans, filled by bots -->
                <input type="text" name="hp_field" [(ngModel)]="hpField" [ngModelOptions]="{standalone: true}"
                    autocomplete="off" tabindex="-1" aria-hidden="true"
                    style="position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;overflow:hidden" />
                <mat-card style="margin: 10px 0px">
                    <mat-card-header>
                        <mat-card-title>Name and affiliation</mat-card-title></mat-card-header>
                    <mat-card-content>
                        <div class="r-flex-row">
                            <div class="r-flex-row" formGroupName="firstAttendee">
                                <mat-form-field class="r-field r-inputfield ">
                                    <mat-label>First name</mat-label>
                                    <input matInput size="100" class="r-custom-input-background"
                                        placeholder="First name" formControlName="firstName">
                                    @if(registrationFormGroup.controls.firstAttendee.controls.firstName.hasError('required'))
                                    {
                                    <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field class="r-field r-inputfield">
                                    <mat-label>Last name</mat-label>
                                    <input matInput placeholder="Last name" formControlName="lastName">
                                    @if(registrationFormGroup.controls.firstAttendee.controls.lastName.hasError('required'))
                                    {
                                    <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field class="r-field r-inputfield">
                                    <mat-label>Email address</mat-label>
                                    <input matInput type="email" placeholder="Email" formControlName="email">
                                    @if(registrationFormGroup.controls.firstAttendee.controls.email.hasError('required'))
                                    {
                                    <mat-error>This field is required.</mat-error>
                                    }
                                    @if(registrationFormGroup.controls.firstAttendee.controls.email.hasError('email')) {
                                    <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <div>
                                <mat-form-field class="r-field r-longinputfield">
                                    <mat-label>Organisation</mat-label>
                                    <input matInput placeholder="Organisation" formControlName="organisation">
                                    @if(registrationFormGroup.controls.organisation.hasError('required')) {
                                    <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <div formGroupName="firstAttendee">
                                <mat-form-field class="r-field r-inputfield">
                                    <mat-label>Job title</mat-label>
                                    <input matInput placeholder="Job title" formControlName="jobTitle">
                                    @if(registrationFormGroup.controls.firstAttendee.controls.jobTitle.hasError('required'))
                                    {
                                    <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>
                            </div>

                        </div>
                        @if (event.allowMultipleRegistrations) {
                        <div style="margin: 0px; font-size: smaller;">Additional participants can be added below</div>
                        }
                        <div [formGroup]="registrationFormGroup.controls.firstAttendee.controls.preferences">
                            <div class="r-section-header">Preferences</div>
                            <div style="margin-left: 25px">
                                @for (group of event.optionGroups; track group.id) {
                                <app-option-group [group]="group" formControlName="{{ group.id }}">
                                </app-option-group>
                                @let pref =
                                registrationFormGroup.controls.firstAttendee.controls.preferences.controls[group.id];

                                @if (pref.invalid && pref.touched) {
                                @if (pref.hasError('exclusiveRequired')) {
                                <mat-error style="font-size: 12px">You must select one option.</mat-error>
                                }
                                @if (pref.hasError('minAnswersRequired')) {
                                <mat-error style="font-size: 12px">Please select at least {{group.minAnswers}}
                                    {{group.minAnswers === 1 ? 'option' : 'options'}}.</mat-error>
                                }
                                @if (pref.hasError('maxAnswersRequired')) {
                                <mat-error style="font-size: 12px">Please do not select more than {{group.max}}
                                    {{group.minAnswers === 1 ? 'option' : 'options'}}.</mat-error>
                                }
                                }
                                }
                            </div>
                        </div>

                        <div>
                            <p hidden>isEarlyBirdActive is {{isEarlyBirdActive}}</p>
                            <div class="r-section-header">Registration fee</div>

                            @if (fees.length === 0) {
                            <p>Strangely enough, no fee is associated with this event</p>
                            } @else if (fees.length === 1) {
                            <p
                                style="font-size: larger; margin-top:15px; padding: 10px 15px 10px 15px; width: fit-content; border: solid thin">
                                Applicable fee:
                                {{baseFee | currency: 'EUR' : 'symbol' : undefined :'fr-BE' }} VAT Excl.
                            </p>
                            } @else {
                            <p style="margin-top: 10px;">Please select the appropriate fee</p>
                            <table mat-table [dataSource]="fees" style="min-width:25%; margin-bottom: 15px">
                                <ng-container matColumnDef="select">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let fee">
                                        <mat-radio-button (click)="toggleFeeSelection(fee)"
                                            [checked]="isFeeSelected(fee)" required></mat-radio-button>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="target">
                                    <th mat-header-cell *matHeaderCellDef> Applicable to </th>
                                    <td mat-cell *matCellDef="let fee"> {{fee.target}} </td>
                                </ng-container>
                                @if(isEarlyBirdActive) {
                                <ng-container matColumnDef="earlyBirdPrice">
                                    <th mat-header-cell *matHeaderCellDef> Early bird price <br />(until {{
                                        (earlyBirdDeadline ? (earlyBirdDeadline | date:
                                        'dd-MM-yyyy')
                                        :
                                        '...') }})</th>
                                    <td mat-cell *matCellDef="let fee"> {{fee.earlyBirdPrice | currency: 'EUR' :
                                        'symbol' :
                                        undefined :'fr-BE'}} </td>
                                </ng-container>
                                }
                                <ng-container matColumnDef="generalPrice">
                                    <th mat-header-cell *matHeaderCellDef> General price </th>
                                    <td mat-cell *matCellDef="let fee"> {{fee.generalPrice | currency: 'EUR' : 'symbol'
                                        :
                                        undefined
                                        :'fr-BE'}}</td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="feeColumnsToDisplay"></tr>
                                <tr mat-row *matRowDef="let myRowData; columns: feeColumnsToDisplay"></tr>
                            </table>
                            }

                        </div>
                    </mat-card-content>
                </mat-card>

                @if (event.allowMultipleRegistrations) {
                <mat-card style="margin: 10px 0px">
                    <mat-card-header><mat-card-title>Additional participants</mat-card-title></mat-card-header>
                    <mat-card-content>
                        <p>If you need to register additional persons from your organisation, feel free to add their
                            details
                            here. The same fee applies to all included participants</p>

                        <div *ngFor="let attendee of additionalAttendees.controls; let i=index"
                            formGroupName="additionalAttendees">
                            <div [formGroupName]="i">
                                <mat-list>
                                    <div style="display: flex; flex-direction: row; align-items: baseline;">
                                        <mat-form-field class="r-field r-inputfield">
                                            <mat-label>First name</mat-label>
                                            <input matInput size="10" placeholder="First name"
                                                formControlName="firstName" required>
                                        </mat-form-field>
                                        <mat-form-field class="r-field r-inputfield">
                                            <mat-label>Last name</mat-label>
                                            <input matInput size="10" placeholder="Last name" formControlName="lastName"
                                                required>
                                        </mat-form-field>
                                        <mat-form-field class="r-field r-inputfield">
                                            <mat-label>Email address</mat-label>
                                            <input matInput type="email" placeholder="Email" formControlName="email"
                                                required>
                                            @if (additionalAttendees.at(i).get('email')!.hasError('email')) {
                                            <mat-error>Email is invalid</mat-error>
                                            }
                                        </mat-form-field>
                                        <mat-form-field class="r-field r-inputfield">
                                            <mat-label>Job title</mat-label>
                                            <input matInput placeholder="Job title" formControlName="jobTitle">
                                        </mat-form-field>

                                        <button mat-icon-button color="primary" (click)="deleteAttendee(i)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>
                                </mat-list>
                                <div [formGroup]="additionalAttendees.at(i).controls.preferences"
                                    style="margin-top: 15px; margin-left: 10px;">
                                    @for (group of event.optionGroups; track group.id) {
                                    <app-option-group [group]="group" formControlName="{{ group.id }}">
                                    </app-option-group>
                                    @let pref = additionalAttendees.at(i).controls.preferences.controls[group.id];

                                    @if (pref.invalid && pref.touched) {
                                    @if (pref.hasError('exclusiveRequired')) {
                                    <mat-error style="font-size: 12px">You must select one option.</mat-error>
                                    }
                                    @if (pref.hasError('minAnswersRequired')) {
                                    <mat-error style="font-size: 12px">Please select at least {{group.minAnswers}}
                                        {{group.minAnswers
                                        === 1 ? 'option' : 'options'}}.</mat-error>
                                    }
                                    @if (pref.hasError('maxAnswersRequired')) {
                                    <mat-error style="font-size: 12px">Please do not select more than
                                        {{group.max}}
                                        {{group.minAnswers
                                        === 1 ? 'option' : 'options'}}.</mat-error>
                                    }
                                    }
                                    }
                                </div>
                            </div>
                        </div>
                        <div style="display: flex; justify-content: center; margin-top: 20px;">
                            <button mat-raised-button color="primary" (click)="addAttendee()">Add participant</button>
                        </div>
                    </mat-card-content>
                </mat-card>
                }

                <mat-card style="margin: 10px 0px">
                    @for (d of event.disclaimers; track d.priority) {
                    <div class="r-disclaimer">
                        <p class="r-disclaimer-title">{{d.title}}</p>
                        <div [innerHTML]="d.body"></div>
                    </div>
                    }
                    @if (event.paymentConditions) {
                    <div class="r-disclaimer">
                        <p class="r-disclaimer-title">{{event.paymentConditions.title}}</p>
                        <div [innerHTML]="event.paymentConditions.body"></div>
                    </div>
                    }
                </mat-card>

                <div class="r-stepper-button-frame-first">
                    <button mat-fab matStepperNext class="r-stepper-button-right" color="primary">
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>
            </form>
        </mat-step>
        <mat-step [stepControl]="invoicingFormGroup" label="Invoicing data">
            <form [formGroup]="invoicingFormGroup">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title>Name and affiliation</mat-card-title></mat-card-header>
                    <mat-card-content>
                        <div class="r-flex-row">
                            <mat-form-field class="r-field r-field-vat">
                                <mat-label>VAT number</mat-label>
                                <input matInput size="100" placeholder="VAT number" formControlName="vatNumber"
                                    width="50" (blur)="checkVAT()">
                            </mat-form-field>
                            <mat-checkbox formControlName="noVAT">No VAT number</mat-checkbox>
                        </div>
                        <div class="r-flex-row">
                            <mat-form-field class="r-field r-field-organization">
                                <mat-label>Organisation name</mat-label>
                                <input matInput size="100" placeholder="Organisation name"
                                    formControlName="organisation" width="50">
                            </mat-form-field>
                        </div>
                        <div class="r-flex-row">
                            <mat-form-field class="r-field r-field-organization">
                                <mat-label>Contact name</mat-label>
                                <input matInput placeholder="Contact name" formControlName="contactName" size="100">
                            </mat-form-field>
                            <mat-form-field class="r-field r-field-organization">
                                <mat-label>Contact email</mat-label>
                                <input matInput placeholder="Contact email" formControlName="contactEmail" size="50">
                                @if (invoicingFormGroup.get('contactEmail')!.hasError('email')) {
                                <mat-error>Email is invalid</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="r-flex-row">
                            <mat-form-field class="r-field r-field-address">
                                <mat-label>Address</mat-label>
                                <input matInput placeholder="Address" formControlName="address1">
                            </mat-form-field>
                            <mat-form-field class="r-field r-field-address">
                                <mat-label>Address complement</mat-label>
                                <input matInput placeholder="Address complement" formControlName="address2">
                            </mat-form-field>
                        </div>
                        <div class="r-flex-row">
                            <mat-form-field class="r-field r-field-zipcode">
                                <mat-label>Postal code</mat-label>
                                <input matInput placeholder="Postal code" formControlName="zipCode">
                            </mat-form-field>
                            <mat-form-field class="r-field r-field-city">
                                <mat-label>City</mat-label>
                                <input matInput placeholder="City" formControlName="city">
                            </mat-form-field>
                            <mat-form-field class="r-field r-field-address">
                                <mat-label>Country</mat-label>
                                <mat-select formControlName="country">
                                    @for (country of countries; track country) {
                                    <mat-option [value]="country.code">{{country.enName}}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="r-flex-row">
                            <mat-form-field class="r-field r-field-po">
                                <mat-label>Optional PO number</mat-label>
                                <input matInput size="100" placeholder="PO number" formControlName="poNumber"
                                    width="50">
                            </mat-form-field>
                        </div>
                    </mat-card-content>
                </mat-card>
            </form>

            <div class="r-stepper-button-frame">
                <button mat-fab matStepperPrevious class="r-stepper-button-left" color="primary">
                    <mat-icon>chevron_left</mat-icon>
                </button>
                <button mat-fab matStepperNext class="r-stepper-button-right" color="primary">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
        </mat-step>
        <mat-step label="Confirmation">
            <form>
                <!-- honeypot: hidden from humans, filled by bots -->
                <input type="text" name="hp_field" [(ngModel)]="hpField" [ngModelOptions]="{standalone: true}"
                    autocomplete="off" tabindex="-1" aria-hidden="true"
                    style="position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;overflow:hidden" />
                <h3>Please carefully check the details of your registration before proceeding to payment</h3>
                <mat-card style="margin: 10px 0px">
                    <mat-card-header>
                        <mat-card-title>Name and affiliation</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        @if (checkoutData()) {
                        <div class="container" style="margin:20px 0px; display: flex">
                            <div style="width: 47%; ">
                                <div class="row">
                                    <div class="col-5 r-output-label">
                                        <span class="">Organisation </span>
                                    </div>
                                    <div class="col-7 r-output-value">
                                        <span class=""> {{checkoutData()!.registrationData!.organisation}} </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-5 r-output-label">
                                        <span class="">Selected fee </span>
                                    </div>
                                    <div class="col-7 r-output-value">
                                        <span class=""> {{checkoutData()!.registrationData!.selectedFee!.target}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container" style="margin:20px 0px; display: flex">
                            <div style="width: 47%; ">
                                <div class="row">
                                    <div class="col-5 r-output-label">
                                        <span class="">Total number of registrations </span>
                                    </div>
                                    <div class="col-7 r-output-value">
                                        <span class=""> {{checkoutData()!.totalTickets}} </span>
                                    </div>
                                </div>
                                @if (checkoutData()!.freeTickets > 0 ) {
                                <div class="row">
                                    <div class="col-5 r-output-label">
                                        <span class="">Free tickets for company delegation</span>
                                    </div>
                                    <div class="col-7 r-output-value">
                                        <span class=""> {{checkoutData()!.freeTickets}} </span>
                                    </div>
                                </div>
                                }
                                <div class="row">
                                    <div class="col-5 r-output-label">
                                        <span class="">Base rate</span>
                                    </div>
                                    <div class="col-7 r-output-value">
                                        <span class=""> {{checkoutData()!.fullRate | currency: 'EUR' : 'symbol' :
                                            undefined :'fr-BE'}} </span>
                                    </div>
                                </div>
                                @if (event.usesPromoCodes) {
                                <div class="row" style="margin-top: 2px; margin-bottom: 2px; display: flex">
                                    <div class="col-5 r-output-label" style="font-style: oblique;margin-top: 10px;">If
                                        you
                                        have a promo code, please enter it here:</div>
                                    <div class="col-7 r-output-value">
                                        <mat-form-field class="r-field r-inputfield" style="padding-left: 0px;">
                                            <mat-label>Promo Code</mat-label>
                                            <input matInput type="text" placeholder="Promo code"
                                                [formControl]="promoCodeControl">
                                            @if (promoCodeControl.hasError('promoCodeError')) {
                                            <mat-error> Code does not exist or is not valid</mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                </div>
                                }
                                <div class="row">
                                    <div class="col-5 r-output-label">
                                        <span class="">Amount to pay</span>
                                    </div>
                                    <div class="col-7 r-output-value">
                                        <span class=""> {{checkoutData()!.totalAmount | currency: 'EUR' : 'symbol' :
                                            undefined :'fr-BE'}} </span>
                                        @if((promoCodeControl.valid) && (promoCode())) {
                                        @if (checkoutData()?.discountRateTickets) {
                                        <span>({{checkoutData()?.fullRateTickets}} at full price +
                                            {{checkoutData()?.discountRateTickets}} at discounted price)</span>
                                        }
                                        @else {
                                        <span>({{checkoutData()?.fullRateTickets}} at full price) </span>
                                        }
                                        }
                                    </div>
                                </div>

                            </div>
                            <div style="width: 47%">

                            </div>
                        </div>
                        }
                    </mat-card-content>
                </mat-card>

                <mat-card style="margin: 10px 0px">
                    <mat-card-header>
                        <mat-card-title>Attendees</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div style="border-style: solid;">
                            <table mat-table [dataSource]="allAttendees">
                                <ng-container matColumnDef="firstName">
                                    <th mat-header-cell *matHeaderCellDef> First name </th>
                                    <td mat-cell *matCellDef="let a"> {{a.firstName}} </td>
                                </ng-container>
                                <ng-container matColumnDef="lastName">
                                    <th mat-header-cell *matHeaderCellDef> Last name </th>
                                    <td mat-cell *matCellDef="let a"> {{a.lastName}} </td>
                                </ng-container>
                                <ng-container matColumnDef="jobTitle">
                                    <th mat-header-cell *matHeaderCellDef> Job title </th>
                                    <td mat-cell *matCellDef="let a"> {{a.jobTitle}} </td>
                                </ng-container>
                                <ng-container matColumnDef="email">
                                    <th mat-header-cell *matHeaderCellDef> email </th>
                                    <td mat-cell *matCellDef="let a"> {{a.email}} </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="attendeesColumnsToDisplay"></tr>
                                <tr mat-row *matRowDef="let myRowData; columns: attendeesColumnsToDisplay"></tr>
                            </table>
                        </div>
                    </mat-card-content>
                </mat-card>

                <mat-card style="margin: 10px 0px">
                    <mat-card-header>
                        <mat-card-title>Invoicing data</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        @if (checkoutData()) {
                        <div style="border-style: solid; padding:10px">
                            <div class="container">
                                <div class="row">
                                    <div class="col-2 r-output-label">
                                        <span class="">Organisation </span>
                                    </div>
                                    <div class="col-4 r-output-value">
                                        <span class=""> {{checkoutData()!.invoicingData!.organisation}} </span>
                                    </div>
                                    <div class="col-2 r-output-label">
                                        <span class="">VAT Number </span>
                                    </div>
                                    <div class="col-4 r-output-value">
                                        <span class=""> {{ checkoutData()!.invoicingData?.vatNumber | blankOrNA}}
                                        </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 r-output-label">
                                        <span class="">Contact name </span>
                                    </div>
                                    <div class="col-4 r-output-value">
                                        <span class=""> {{checkoutData()!.invoicingData!.contactName}} </span>
                                    </div>
                                    <div class="col-2 r-output-label">
                                        <span class="">Contact email </span>
                                    </div>
                                    <div class="col-4 r-output-value">
                                        <span class=""> {{checkoutData()!.invoicingData!.contactEmail}} </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 r-output-label">
                                        <span class="">Address </span>
                                    </div>
                                    <div class="col-4 r-output-value">
                                        <span class=""> {{checkoutData()!.invoicingData!.address1}} </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="offset-sm-2 col-4 r-output-value">
                                        <span class=""> {{checkoutData()!.invoicingData?.address2}} </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="offset-sm-2 col-1 r-output-value">
                                        <span class=""> {{checkoutData()!.invoicingData!.zipCode}} </span>
                                    </div>
                                    <div class="col-2 r-output-value">
                                        <span class=""> {{checkoutData()!.invoicingData!.city}} </span>
                                    </div>
                                    <div class="col-1 r-output-value">
                                        <span class=""> {{checkoutData()!.invoicingData!.country}} </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 r-output-label">
                                        <span class=""> PO Number </span>
                                    </div>
                                    <div class="col-1 r-output-value">
                                        <span class=""> {{ checkoutData()!.invoicingData?.poNumber | blankOrNA}} </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                    </mat-card-content>
                </mat-card>

                @if (event.paymentConditions) {
                <h3 mat-subheader style="margin-top:20px">Important information</h3>
                <h4>{{event.paymentConditions.title}}</h4>
                <div [innerHTML]="event.paymentConditions.body"></div>
                }

                <div class="r-stepper-button-frame">
                    <button mat-fab matStepperPrevious class="r-stepper-button-left" color="primary">
                        <mat-icon>chevron_left</mat-icon>
                    </button>
                    @if (checkoutData()) {
                    <button mat-fab extended color="accent" (click)="checkout()">
                        Register
                    </button>
                    }
                </div>
            </form>
        </mat-step>
    </mat-stepper>
</div>